class CampaignController {
  constructor() {
    this.name = 'campaign';
  }
}

export default CampaignController;



// WEBPACK FOOTER //
// ./client/app/components/campaign/campaign.controller.js